export const STYLIST_CARD_TITLE_CLASS =
    " text-[40px] md:text-7xl w-full align-bottom text-white font-libre mt-[450px] md:mt-[600px]  group-hover:mt-[20%] group-focus:mt-[20%] group-active:mt-[20%]  -rotate-90  group-active:align-baseline group-active:rotate-0  group-hover:align-baseline group-hover:rotate-0 group-hover:static group-active:static transition-rotate duration-500 delay-700 ease-in-out";
export const TEXT_LEFT_ALIGNMENT_ON_HOVER =
    "group-active:text-left group-hover:text-left";
export const TEXT_RIGHT_ALIGNMENT_ON_HOVER =
    "group-active:!text-right group-hover:text-right";
